import {
    defineStore,
} from 'pinia';
import * as logger from '../utils/logger';
import {
    getHeader,
} from '../services/app-shell';

const maxAge = 5 * 60 * 1000;

export const useHeaderStore = defineStore('header', {
    state: () => ({
        response: null,
        hash: null,
        expireTime: 0,
    }),
    actions: {
        setHeaderResponse(response) {
            this.response = response;
        },
        setHeaderHash(hash) {
            this.hash = hash;
        },
        setHeaderExpireTime(expireTime) {
            this.expireTime = expireTime;
        },
        async fetchHeader(model) {
            try {
                this.setHeaderResponse(null);

                const response = await getHeader(model);
                const expireTime = Date.now() + maxAge;

                this.setHeaderResponse(response);
                this.setHeaderExpireTime(expireTime);
            } catch (exception) {
                this.setHeaderResponse(null);

                /* istanbul ignore next */
                logger.error({
                    exception,
                    tags: {
                        user_info: logger.userInfoTags.INLINE,
                    },
                });
            }
        },
    },
});
